export default __webpack_public_path__ + "static/media/4.482e0311.jpg";